import { Component, Input, SimpleChanges } from '@angular/core';
import { reportTitals } from '@piqet-angular/shared';
import { ReportsService } from 'libs/data/src/lib/services/report/reports.service';

@Component({
  selector: 'piqet-angular-report-ingredientdatasource-details',
  templateUrl: './report-ingredientdatasource-details.component.html',
  styleUrls: ['./report-ingredientdatasource-details.component.scss'],
})
export class ReportIngredientdatasourceDetailsComponent {
  @Input() impactItems: any;
  @Input() isExportFlag: any;
  @Input() isApiCall: any = false;
  reportResource = reportTitals;

  constructor(private reportService: ReportsService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (this.isApiCall) {
      this.getIngredientDatasourceDetails();
    } else {
      this.impactItems = changes['impactItems'].currentValue;
    }
  }

  //  ngOnInit() {
  //   if(this.isApiCall){
  //     this.getIngredientDatasourceDetails()
  //   }
  //   }

  async getIngredientDatasourceDetails() {
    const response = await this.reportService.getIngredientDatasourceDetails(
      this.impactItems.productId,
      this.isExportFlag
    );
    this.impactItems = response.data;
  }
}
